<template>
  <ul id="slide-out" class="sidenav">
    <li>
      <div class="user-view">
        <img
          src="ui/img/logo.png"
          class="responsive-img"
          alt="iRecharge Logo"
        />
        <div class="background">
          <img src="ui/img/background.jpg" />
        </div>
      </div>
    </li>
    <li>
      <router-link to="/" class="waves-effect">
        <i class="fa fa-lightbulb-o" style="color: #000"></i> Electricity
      </router-link>
    </li>
    <li>
      <router-link to="/airtime" class="waves-effect">
        <i class="fa fa-mobile" style="color: #000"></i> Airtime
      </router-link>
    </li>
    <li>
      <router-link to="/data" class="waves-effect">
        <i class="fa fa-globe" style="color: #000"></i> Data
      </router-link>
    </li>
    <li>
      <router-link to="/tv" class="waves-effect">
        <i class="fa fa-tv" style="color: #000"></i> TV
      </router-link>
    </li>
    <li v-if="userType == 1">
      <router-link to="/transaction" class="waves-effect">
        <i class="fa fa-history" style="color: #000"></i> Transaction History
      </router-link>
    </li>
    <li><div class="divider"></div></li>
    <li>
      <a class="waves-effect" href="#!" @click="login('vendor')"
        >Become a Merchant</a
      >
    </li>
    <li><div class="divider"></div></li>
    <li class="dropdown">
      Our Solutions <i class="material-icons">arrow_drop_down</i>
    </li>
    <li class="level2 hide">
      <router-link to="/irecharge_plus" class="waves-effect">
        User
      </router-link>
    </li>
    <li class="level2 hide">
      <router-link to="/irecharge_corporate" class="waves-effect">
        Corporate
      </router-link>
    </li>
    <li class="level2 hide">
      <router-link to="/irecharge_merchant" class="waves-effect">
        Merchant
      </router-link>
    </li>
    <li class="level2 hide">
      <router-link to="/irecharge_api" class="waves-effect">
        API
      </router-link>
    </li>
    <li class="level2 hide">
      <router-link to="/irecharge_perks" class="waves-effect">
        Perks
      </router-link>
    </li>
    <li>
      <router-link to="/irecharge_pay" class="waves-effect">
        iRecharge Pay
      </router-link>
    </li>
    <li><div class="divider"></div></li>
    <li>
      <router-link to="/request_token" class="waves-effect">
        Lost your token?
      </router-link>
    </li>
    <li><div class="divider"></div></li>
    <li>
      <router-link to="/about" class="waves-effect">
        About Us
      </router-link>
    </li>
    <!-- <li><a class="waves-effect" href="#!">Help &amp; Support</a></li> -->
    <li>
      <router-link to="/terms-and-condition" class="waves-effect">
        Terms &amp; Conditions
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  mounted() {
    this.getUserType()
  },
  data() {
    return {
      userType: ''
    }
  },
  methods: {
    login(option) {
      document.getElementById('myNav').style.width = '100%'
      this.$emit('modal-option', option)
    },
    getUserType() {
      this.userType = localStorage.getItem('userType')
    }
  }
}
</script>

<style scoped>
.hide {
  display: none;
}
</style>
